import React from "react"
import { theme } from "../../../utils/themeGet"
import { Box } from '@sqymagma/elements'

export default({color = "ui02"}) => {
  return (
      <Box as="span" my="s" mh="auto"  display="block" css={`border-top: 1px dotted ${theme(`color.${color}`)}`}/>
  )
}
